const HEALTH_CHECK_URL = 'http://localhost:8009/health';
const CACHE_DURATION_MS = 60 * 60 * 1000; // 1 hour
const HEALTH_CHECK_TIMEOUT_MS = 500;

let cachedCheck: Promise<boolean> | null = null;
let cacheExpiresAt = 0;

async function checkMockServerHealth(): Promise<boolean> {
    try {
        const response = await fetch(HEALTH_CHECK_URL, {
            signal: AbortSignal.timeout(HEALTH_CHECK_TIMEOUT_MS),
        });
        return response.ok;
    } catch {
        return false;
    }
}

export async function isMockServerRunning(): Promise<boolean> {
    if (!cachedCheck || Date.now() >= cacheExpiresAt) {
        cacheExpiresAt = Date.now() + CACHE_DURATION_MS;
        cachedCheck = checkMockServerHealth();
    }
    return cachedCheck;
}
